<div class="wrapper">
    <button class="switcher" [disabled]="!appliedFiltersCount" (click)="toggleFiltersDisplay()">
        <app-icon [type]="'Plus'" *ngIf="!shouldDisplayAppliedFilters"></app-icon>
        <app-icon [type]="'Minus'" *ngIf="shouldDisplayAppliedFilters"></app-icon>
        Filters
        <span class="filters-count">({{ appliedFiltersCount }})</span>
    </button>
    <button class="select-filters" (click)="openMobileFilters()">
        Select filters
        <app-icon [type]="'Pencil'"></app-icon>
    </button>
    <app-applied-filters
        [shouldBeDisplayed]="shouldDisplayAppliedFilters"
        [searchInfo]="searchInfo"
    ></app-applied-filters>
</div>
